import { Autocomplete, Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import { createRef } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { ProductGroupDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { costTypes } from '../calculationTypes';
type OwnProps = {
    handleAmountChange: (val: number) => void;
    useBasePrice: boolean;
    handleUseBasePrice: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleProductGroupChanged: (value: ProductGroupDto | null) => void;
    amount: number;
    productGroupId: number | undefined;
};

const mapStateToProps = (
    state: RootState,
    {
        handleAmountChange,
        useBasePrice,
        handleUseBasePrice,
        handleProductGroupChanged,
        amount,
        productGroupId
    }: OwnProps
) => ({
    costType: state.calculation.showCreateNewCostDialog.costTypeId,
    handleAmountChange: handleAmountChange,
    useBasePrice: useBasePrice,
    handleUseBasePrice: handleUseBasePrice,
    handleProductGroupChanged: handleProductGroupChanged,
    amount: amount,
    productGroupId,
    productGroups: state.product.productGroups
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductGroupCostDialogContent = ({
    costType,
    handleAmountChange,
    handleUseBasePrice,
    handleProductGroupChanged,
    useBasePrice,
    amount,
    productGroupId,
    productGroups
}: Props) => {
    const getAmountLabel = () => {
        return costTypes[costType as number];
    };
    const amountInputRef = createRef();

    return (
        <div>
            <Grid container direction="column">
                <Autocomplete
                    onChange={(_, value) => handleProductGroupChanged(value)}
                    value={productGroupId != null ? productGroups[productGroupId] : null}
                    options={Object.values(productGroups)}
                    getOptionLabel={group => group.name}
                    renderInput={params => <TextField {...params} label="" variant="outlined" fullWidth />}
                />

                <NumberFormat
                    getInputRef={amountInputRef}
                    style={{ padding: '6px 0 7px', marginTop: '12px' }}
                    customInput={TextField}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    suffix={` ${getAmountLabel()}`}
                    sx={{ marginTop: '48px' }}
                    decimalScale={2}
                    fixedDecimalScale={true}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={useBasePrice}
                            onChange={handleUseBasePrice}
                            name="useBasePrice"
                            color="primary"
                        />
                    }
                    label="Calculate using base price"
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(ProductGroupCostDialogContent);
